import React, { useState, useEffect, useRef } from 'react';

const TestimonialCard = ({ imageSrc, name, testimonialText }) => {
    const [expanded, setExpanded] = useState(false);
    const charLimit = 160;
    const isLong = testimonialText.length > charLimit;

    return (
        <div className="carousel-card">
            <img className="testimonial-image" src={imageSrc} alt={`${name} - Client testimonial`} loading="lazy" />
            <div className="carousel-card-text">
                <h4 className="text-brand-800 font-semibold">{name}</h4>
                <p className="text-textBody text-sm leading-relaxed">
                    {isLong && !expanded
                        ? `${testimonialText.slice(0, charLimit)}...`
                        : testimonialText}
                </p>
                {isLong && (
                    <button
                        className="text-brand-800 font-semibold text-sm mt-1 hover:underline cursor-pointer"
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? 'Read less' : 'Read more'}
                    </button>
                )}
            </div>
        </div>
    );
};

const TestimonialCarousel = ({ testimonials }) => {
    const trackRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        let animationId;
        let scrollPos = 0;
        const speed = 0.5;

        const step = () => {
            if (!isPaused && track && window.innerWidth < 768) {
                scrollPos += speed;
                const halfScroll = track.scrollWidth / 2;
                if (scrollPos >= halfScroll) {
                    scrollPos = 0;
                }
                track.scrollLeft = scrollPos;
            }
            animationId = requestAnimationFrame(step);
        };

        animationId = requestAnimationFrame(step);
        return () => cancelAnimationFrame(animationId);
    }, [isPaused]);

    const doubled = [...testimonials, ...testimonials];

    return (
        <div className="carousel-wrapper">
            {/* Mobile: horizontal auto-scroll */}
            <div
                className="carousel-track md:hidden"
                ref={trackRef}
                onTouchStart={() => setIsPaused(true)}
                onTouchEnd={() => setIsPaused(false)}
            >
                {doubled.map((t, i) => (
                    <TestimonialCard key={i} {...t} />
                ))}
            </div>

            {/* Desktop: normal grid */}
            <div className="hidden md:flex testimonial-grid">
                {testimonials.map((t, i) => (
                    <TestimonialCard key={i} {...t} />
                ))}
            </div>
        </div>
    );
};

export default TestimonialCarousel;
